{
  "title": "My team",
  "subtitle_one": "{{count}} direct report",
  "subtitle_other": "{{count}} direct reports",
  "directReports": "Direct reports",
  "directReportsHint": "Employees whose manager or secondary manager is you.",
  "members": "Team members",
  "noDirectory": "Your role cannot open your reports' employee records, so the list stays hidden. Ask HR for a role with the employee.view_team permission (the Line Manager role has it) to see your reports here.",
  "empty": "No direct reports found",
  "emptyHint": "Nobody reports to your employee record yet. HR sets the manager and secondary manager on each employee profile.",
  "notManager": "You have no direct reports",
  "notManagerHint": "This page opens for members whose employee record is the manager or secondary manager of other employees.",
  "columns": { "name": "Name", "designation": "Designation", "department": "Department", "branch": "Branch", "relation": "Reports to you as" },
  "relation": { "primary": "Manager", "secondary": "Secondary manager" },
  "tabs": { "today": "Today", "attendance": "Attendance", "leave": "Leave", "approvals": "Approvals", "delegation": "Delegation" },
  "refresh": "Refresh",
  "updated": "Updated {{when}}",
  "today": {
    "status": {
      "present": "Present",
      "late": "Late",
      "absent": "Absent",
      "on_leave": "On leave",
      "missing_punch": "Missing punch",
      "weekly_off": "Weekly off",
      "holiday": "Holiday",
      "not_in_yet": "Not in yet",
      "not_scheduled": "Not scheduled"
    },
    "live": { "IN": "In now", "OUT": "Checked out", "NONE": "No punch yet" },
    "firstIn": "In",
    "lastOut": "Out",
    "worked": "Worked",
    "workedLive": "Worked so far (live)",
    "lateBy": "{{time}} late",
    "halfDay": "{{type}} · half day",
    "pending_one": "{{count}} waiting for you",
    "pending_other": "{{count}} waiting for you",
    "openDay": "Open the day",
    "noRecord": "Not calculated yet",
    "totals": { "present": "Present", "late": "Late", "absent": "Absent", "onLeave": "On leave", "missingPunch": "Missing punch", "inNow": "In now", "presentHint": "Late arrivals included", "ofReports": "of {{count}}" },
    "search": "Search your team",
    "searchPlaceholder": "Name or employee number",
    "noMatch": "Nobody in your team matches “{{search}}”.",
    "empty": "No reports to show",
    "emptyHint": "Your reports appear here once their employee records are active.",
    "noAttendanceKey": "Your role cannot read your reports' attendance. Ask HR for a role with the attendance.view_team permission (the Line Manager role has it) to see today's board."
  },
  "attendance": {
    "month": "Month",
    "day": "Day",
    "previous": "Previous month",
    "next": "Next month",
    "employee": "Employee",
    "allReports": "All reports",
    "date": "Date",
    "empty": "No attendance records in this range",
    "emptyHint": "Records appear once punches arrive and the engine calculates the day.",
    "readOnly": "Read-only: requesting a correction needs the attendance.correct permission.",
    "notAReport": "That employee is not one of your direct reports: showing your whole team.",
    "columns": { "employee": "Employee", "status": "Status", "in": "In", "out": "Out", "worked": "Worked", "late": "Late" },
    "prevPage": "Previous page",
    "nextPage": "Next page",
    "page": "Page {{page}} of {{pages}} · {{total}} reports"
  },
  "leave": {
    "upcoming": "Upcoming leave",
    "upcomingHint": "Approved and pending leave of your reports that ends today or later (at most 20).",
    "calendar": "Team leave calendar",
    "includePending": "Include pending",
    "pendingForMe_one": "{{count}} leave request is waiting for you",
    "pendingForMe_other": "{{count}} leave requests are waiting for you",
    "review": "Review",
    "empty": "No leave in this month",
    "emptyHint": "Approved and pending leave of your reports appears here.",
    "days": "Days",
    "previous": "Previous month",
    "next": "Next month",
    "range": "{{from}} → {{to}}"
  },
  "approvals": {
    "mine": "Waiting for me",
    "team": "All my team",
    "teamHint": "View only: the {{count}} most recent requests of your direct reports. Decisions happen on the rows waiting for you.",
    "requests": "Requests",
    "requestsEmpty": "No requests are waiting for you",
    "requestsEmptyHint": "Leave, corrections and other requests routed to you appear here.",
    "teamEmpty": "No requests from your team yet",
    "more": "{{count}} more waiting in the approvals inbox",
    "openInbox": "Open the approvals inbox",
    "reasons": "Attendance reasons",
    "reasonsHint": "Reasons your reports gave for their days. You decide the ones waiting for you; rows seen through HR oversight are marked.",
    "reasonsEmpty": "No reasons are waiting for you",
    "reasonsEmptyHint": "When a report explains a late, absent or incomplete day, the reason appears here.",
    "showAll": "Show decided reasons too",
    "viewOnly": "View only",
    "waitingForAnswer": "Waiting for the employee's answer",
    "noTeamKey": "Your role cannot list your team's requests (attendance.view_team or leave.view_team is needed)."
  },
  "delegation": {
    "title": "Delegation",
    "hint": "While you are away, a delegate decides the requests routed to you. Delegations you create or receive are listed here.",
    "manage": "Open the delegations page"
  },
  "chip": {
    "label_one": "{{count}} item waiting for you",
    "label_other": "{{count}} items waiting for you",
    "approvals_one": "{{count}} approval request",
    "approvals_other": "{{count}} approval requests",
    "notes_one": "{{count}} attendance reason",
    "notes_other": "{{count}} attendance reasons"
  }
}
